// extracted by mini-css-extract-plugin
export default {"container":"percent-overdue_container__ZxqSY","guageContainer":"percent-overdue_guageContainer__meaCV","guageLabel":"percent-overdue_guageLabel__ThmUs"};